export const ROUTES = {
  PLANT_LIST: '/plants',
  PLANT_DETAIL: '/plants/:plantId',
  DASHBOARD: '/dashboard',
  DASHBOARD_UNAVAILABLE: '/dashboard-unavailable',
  SUMMARY: '/summary',
  ADMIN_DASHBOARD: {
    LIST: '/summaryDashboards',
    DETAIL: '/summaryDashboards/:dashboardId',
    DASHBOARD: '/summaryDashboard',
  },
}
